module.exports = __webpack_public_path__ + "img/social.8c00e4d.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/social.svg
// module id = ./assets/images/social.svg
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14